// Categories
import i18n from '@/i18n';

export const CATEGORIES = [
  { value: 'alimentaire', label: 'Alimentaire', icon: '🍎' },
  { value: 'boissons', label: 'Boissons', icon: '🥤' },
  { value: 'materiaux', label: 'Matériaux', icon: '🧱' },
  { value: 'equipements', label: 'Équipements', icon: '⚙️' },
  { value: 'matieres_premieres', label: 'Matières premières', icon: '🪨' },
  { value: 'hygiene', label: 'Hygiène', icon: '🧴' },
  { value: 'chimie', label: 'Chimie', icon: '🧪' },
  { value: 'textile', label: 'Textile', icon: '👕' },
  { value: 'electronique', label: 'Électronique', icon: '💻' },
  { value: 'autre', label: 'Autre', icon: '📦' }
];

// Units
export const UNITS = [
  { value: 'piece', label: 'Pièce' },
  { value: 'kg', label: 'Kilogramme (kg)' },
  { value: 'g', label: 'Gramme (g)' },
  { value: 'L', label: 'Litre (L)' },
  { value: 'mL', label: 'Millilitre (mL)' },
  { value: 'm', label: 'Mètre (m)' },
  { value: 'cm', label: 'Centimètre (cm)' },
  { value: 'm²', label: 'Mètre carré (m²)' },
  { value: 'm³', label: 'Mètre cube (m³)' },
  { value: 'T', label: 'Tonne (T)' },
  { value: 'palette', label: 'Palette' },
  { value: 'carton', label: 'Carton' },
  { value: 'lot', label: 'Lot' }
];

// TVA rates
export const TVA_RATES = [
  { value: 0, label: '0% (Exonéré)' },
  { value: 2.1, label: '2.1% (Presse)' },
  { value: 5.5, label: '5.5% (Alimentaire)' },
  { value: 10, label: '10% (Restauration)' },
  { value: 20, label: '20% (Standard)' }
];

// Temperature ranges
export const TEMP_RANGES = [
  { value: 'ambient', label: 'Température ambiante (15-25°C)' },
  { value: 'refrigerated', label: 'Réfrigéré (0-4°C)' },
  { value: 'frozen', label: 'Surgelé (-18°C)' },
  { value: 'deep_frozen', label: 'Surgélation profonde (-25°C)' },
  { value: 'controlled', label: 'Température contrôlée' }
];

// Countries
export const COUNTRIES = [
  { code: 'AF', name: 'Afghanistan' },
  { code: 'ZA', name: 'Afrique du Sud' },
  { code: 'AL', name: 'Albanie' },
  { code: 'DZ', name: 'Algérie' },
  { code: 'DE', name: 'Allemagne' },
  { code: 'AD', name: 'Andorre' },
  { code: 'AO', name: 'Angola' },
  { code: 'AG', name: 'Antigua-et-Barbuda' },
  { code: 'SA', name: 'Arabie saoudite' },
  { code: 'AR', name: 'Argentine' },
  { code: 'AM', name: 'Arménie' },
  { code: 'AU', name: 'Australie' },
  { code: 'AT', name: 'Autriche' },
  { code: 'AZ', name: 'Azerbaïdjan' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'BH', name: 'Bahreïn' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BB', name: 'Barbade' },
  { code: 'BE', name: 'Belgique' },
  { code: 'BZ', name: 'Belize' },
  { code: 'BJ', name: 'Bénin' },
  { code: 'BT', name: 'Bhoutan' },
  { code: 'BY', name: 'Biélorussie' },
  { code: 'MM', name: 'Birmanie (Myanmar)' },
  { code: 'BO', name: 'Bolivie' },
  { code: 'BA', name: 'Bosnie-Herzégovine' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BR', name: 'Brésil' },
  { code: 'BN', name: 'Brunei' },
  { code: 'BG', name: 'Bulgarie' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BI', name: 'Burundi' },
  { code: 'KH', name: 'Cambodge' },
  { code: 'CM', name: 'Cameroun' },
  { code: 'CA', name: 'Canada' },
  { code: 'CV', name: 'Cap-Vert' },
  { code: 'CL', name: 'Chili' },
  { code: 'CN', name: 'Chine' },
  { code: 'CY', name: 'Chypre' },
  { code: 'CO', name: 'Colombie' },
  { code: 'KM', name: 'Comores' },
  { code: 'CG', name: 'Congo' },
  { code: 'CD', name: 'Congo (RDC)' },
  { code: 'KR', name: 'Corée du Sud' },
  { code: 'KP', name: 'Corée du Nord' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'CI', name: "Côte d'Ivoire" },
  { code: 'HR', name: 'Croatie' },
  { code: 'CU', name: 'Cuba' },
  { code: 'CW', name: 'Curaçao' },
  { code: 'DK', name: 'Danemark' },
  { code: 'DJ', name: 'Djibouti' },
  { code: 'DM', name: 'Dominique' },
  { code: 'EG', name: 'Égypte' },
  { code: 'AE', name: 'Émirats arabes unis' },
  { code: 'EC', name: 'Équateur' },
  { code: 'ER', name: 'Érythrée' },
  { code: 'ES', name: 'Espagne' },
  { code: 'EE', name: 'Estonie' },
  { code: 'SZ', name: 'Eswatini' },
  { code: 'US', name: 'États-Unis' },
  { code: 'ET', name: 'Éthiopie' },
  { code: 'FJ', name: 'Fidji' },
  { code: 'FI', name: 'Finlande' },
  { code: 'FR', name: 'France' },
  { code: 'GA', name: 'Gabon' },
  { code: 'GM', name: 'Gambie' },
  { code: 'GE', name: 'Géorgie' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GR', name: 'Grèce' },
  { code: 'GD', name: 'Grenade' },
  { code: 'GL', name: 'Groenland' },
  { code: 'GP', name: 'Guadeloupe' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GN', name: 'Guinée' },
  { code: 'GQ', name: 'Guinée équatoriale' },
  { code: 'GW', name: 'Guinée-Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'GF', name: 'Guyane française' },
  { code: 'HT', name: 'Haïti' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HK', name: 'Hong Kong' },
  { code: 'HU', name: 'Hongrie' },
  { code: 'IN', name: 'Inde' },
  { code: 'ID', name: 'Indonésie' },
  { code: 'IQ', name: 'Irak' },
  { code: 'IR', name: 'Iran' },
  { code: 'IE', name: 'Irlande' },
  { code: 'IS', name: 'Islande' },
  { code: 'IL', name: 'Israël' },
  { code: 'IT', name: 'Italie' },
  { code: 'JM', name: 'Jamaïque' },
  { code: 'JP', name: 'Japon' },
  { code: 'JO', name: 'Jordanie' },
  { code: 'KZ', name: 'Kazakhstan' },
  { code: 'KE', name: 'Kenya' },
  { code: 'KG', name: 'Kirghizistan' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'KW', name: 'Koweït' },
  { code: 'LA', name: 'Laos' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LV', name: 'Lettonie' },
  { code: 'LB', name: 'Liban' },
  { code: 'LR', name: 'Liberia' },
  { code: 'LY', name: 'Libye' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LT', name: 'Lituanie' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MK', name: 'Macédoine du Nord' },
  { code: 'MG', name: 'Madagascar' },
  { code: 'MY', name: 'Malaisie' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MV', name: 'Maldives' },
  { code: 'ML', name: 'Mali' },
  { code: 'MT', name: 'Malte' },
  { code: 'MA', name: 'Maroc' },
  { code: 'MQ', name: 'Martinique' },
  { code: 'MU', name: 'Maurice' },
  { code: 'MR', name: 'Mauritanie' },
  { code: 'YT', name: 'Mayotte' },
  { code: 'MX', name: 'Mexique' },
  { code: 'MD', name: 'Moldavie' },
  { code: 'MC', name: 'Monaco' },
  { code: 'MN', name: 'Mongolie' },
  { code: 'ME', name: 'Monténégro' },
  { code: 'MZ', name: 'Mozambique' },
  { code: 'NA', name: 'Namibie' },
  { code: 'NR', name: 'Nauru' },
  { code: 'NP', name: 'Népal' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NE', name: 'Niger' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'NO', name: 'Norvège' },
  { code: 'NC', name: 'Nouvelle-Calédonie' },
  { code: 'NZ', name: 'Nouvelle-Zélande' },
  { code: 'OM', name: 'Oman' },
  { code: 'UG', name: 'Ouganda' },
  { code: 'UZ', name: 'Ouzbékistan' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PW', name: 'Palaos' },
  { code: 'PS', name: 'Palestine' },
  { code: 'PA', name: 'Panama' },
  { code: 'PG', name: 'Papouasie-Nouvelle-Guinée' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'NL', name: 'Pays-Bas' },
  { code: 'PE', name: 'Pérou' },
  { code: 'PH', name: 'Philippines' },
  { code: 'PL', name: 'Pologne' },
  { code: 'PF', name: 'Polynésie française' },
  { code: 'PR', name: 'Porto Rico' },
  { code: 'PT', name: 'Portugal' },
  { code: 'QA', name: 'Qatar' },
  { code: 'CF', name: 'République centrafricaine' },
  { code: 'DO', name: 'République dominicaine' },
  { code: 'CZ', name: 'République tchèque' },
  { code: 'RE', name: 'La Réunion' },
  { code: 'RO', name: 'Roumanie' },
  { code: 'GB', name: 'Royaume-Uni' },
  { code: 'RU', name: 'Russie' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'BL', name: 'Saint-Barthélemy' },
  { code: 'KN', name: 'Saint-Christophe-et-Niévès' },
  { code: 'SM', name: 'Saint-Marin' },
  { code: 'MF', name: 'Saint-Martin' },
  { code: 'PM', name: 'Saint-Pierre-et-Miquelon' },
  { code: 'VC', name: 'Saint-Vincent-et-les-Grenadines' },
  { code: 'LC', name: 'Sainte-Lucie' },
  { code: 'SB', name: 'Salomon' },
  { code: 'SV', name: 'Salvador' },
  { code: 'WS', name: 'Samoa' },
  { code: 'ST', name: 'Sao Tomé-et-Principe' },
  { code: 'SN', name: 'Sénégal' },
  { code: 'RS', name: 'Serbie' },
  { code: 'SC', name: 'Seychelles' },
  { code: 'SL', name: 'Sierra Leone' },
  { code: 'SG', name: 'Singapour' },
  { code: 'SK', name: 'Slovaquie' },
  { code: 'SI', name: 'Slovénie' },
  { code: 'SO', name: 'Somalie' },
  { code: 'SD', name: 'Soudan' },
  { code: 'SS', name: 'Soudan du Sud' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'SE', name: 'Suède' },
  { code: 'CH', name: 'Suisse' },
  { code: 'SR', name: 'Suriname' },
  { code: 'SY', name: 'Syrie' },
  { code: 'TJ', name: 'Tadjikistan' },
  { code: 'TW', name: 'Taïwan' },
  { code: 'TZ', name: 'Tanzanie' },
  { code: 'TD', name: 'Tchad' },
  { code: 'TH', name: 'Thaïlande' },
  { code: 'TL', name: 'Timor oriental' },
  { code: 'TG', name: 'Togo' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TT', name: 'Trinité-et-Tobago' },
  { code: 'TN', name: 'Tunisie' },
  { code: 'TM', name: 'Turkménistan' },
  { code: 'TR', name: 'Turquie' },
  { code: 'TV', name: 'Tuvalu' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'VU', name: 'Vanuatu' },
  { code: 'VA', name: 'Vatican' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'YE', name: 'Yémen' },
  { code: 'ZM', name: 'Zambie' },
  { code: 'ZW', name: 'Zimbabwe' }
];

// Zones
export const ZONES = [
  { code: 'GUADELOUPE', name: 'Guadeloupe' },
  { code: 'MARTINIQUE', name: 'Martinique' },
  { code: 'GUYANE', name: 'Guyane' },
  { code: 'REUNION', name: 'La Réunion' },
  { code: 'MAYOTTE', name: 'Mayotte' }
];

// Allergens
export const ALLERGENS = [
  'gluten', 'crustacés', 'oeufs', 'poissons', 'arachides',
  'soja', 'lait', 'fruits à coque', 'céleri', 'moutarde',
  'sésame', 'sulfites', 'lupin', 'mollusques'
];

// Default empty product
export const getEmptyProduct = (category = 'alimentaire') => ({
  sku: '',
  ean: '',
  manufacturer_ref: '',
  name: '',
  short_description: '',
  description: '',
  category: category,
  subcategory: '',
  tags: [],
  brand: '',
  manufacturer: '',
  status: 'draft',
  is_active: true,
  is_new: false,
  is_featured: false,
  unit_type: category === 'alimentaire' ? 'kg' : 'piece',
  unit_label: '',
  // Pricing
  price_ht_cents: 0,
  tva_rate: category === 'alimentaire' ? 5.5 : 20,
  // Dimensions
  length_cm: '',
  width_cm: '',
  height_cm: '',
  volume_l: '',
  // Weight
  net_weight_kg: '',
  gross_weight_kg: '',
  // Origin
  country_code: 'FR',
  region: '',
  producer_name: '',
  // Packaging
  unit_per_pack: 1,
  pack_per_carton: '',
  carton_per_pallet: '',
  packaging_type: '',
  is_recyclable: false,
  // Conservation (food)
  temperature_range: 'ambient',
  shelf_life_days: '',
  dlc_type: 'DDM',
  storage_instructions: '',
  // Nutrition (food)
  energy_kcal: '',
  fat_g: '',
  carbohydrates_g: '',
  protein_g: '',
  salt_g: '',
  nutri_score: '',
  // Allergens
  allergens_contains: [],
  allergens_may_contain: [],
  // Ingredients
  ingredients: '',
  // Technical specs (equipment/materials)
  material: '',
  power_watts: '',
  voltage: '',
  norms: [],
  // Warranty
  warranty_months: 12,
  // Compliance
  ce_marking: false,
  haccp_compliant: false,
  organic_certified: false,
  reach_compliant: false,
  // Logistics
  // Logistics
  lead_time_days: 3,
  min_order_quantity: 1,
  available_zones: ['GUADELOUPE', 'MARTINIQUE', 'GUYANE', 'REUNION', 'MAYOTTE'],
  delivery_type: category === 'alimentaire' ? 'Fret maritime' : 'Livraison standard',
  incoterm: category === 'alimentaire' ? 'CIF' : 'DDP',
  is_fragile: false,
  requires_adr: false
});

export const formatPrice = (cents) => {
  return new Intl.NumberFormat(i18n.language, { style: 'currency', currency: 'EUR' }).format((cents || 0) / 100);
};
